import React from "react";

const Footer = () => {
  return (
    <footer>
      <div className="column credit">
        <a href="https://summerrollison.com/" target="_blank">
          Created by Summer Rollison
        </a>
      </div>
      <div className="column">
        <div className="badge" id="edamam-badge" data-color="light"></div>
      </div>
    </footer>
  );
};

export default Footer;
